import React, {Component, Fragment} from "react";
import Header from "./Header";
import VotesByHour from "./VotesByHour";
import TurnoutTable from "./TurnoutTable";
import ResultsTable from "./ResultsTable";
import axios from "axios";
import Footer from "./Footer";
import RolloutSummary from "./RolloutSummary";
import RolloutSummaryW from "./RolloutSummaryW";
import TurnoutDropInTable from "./TurnoutDropInTable";

class Home extends Component {

    constructor(props) {
        super(props);

        this.election_id = '7nXgtlaq';


        this.state = {
            snapshot: null,
            election: null,
            loading: false,
            comuna: null
        };
    }

    componentDidMount() {

        console.log(this.props.match.params.comuna);

        this.loadElection(this.election_id);
        this.loadSnapshot(this.election_id);

        switch (this.props.match.params.comuna) {
            case 'antofagasta':
                this.setState({
                    comuna: {
                        district: 'D12',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_antofagasta.png",
                        name: "Antofagasta",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'independencia':
                this.setState({
                    comuna: {
                        district: 'D114',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_independencia.png",
                        name: "Independencia",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'cerronavia':
                this.setState({
                    comuna: {
                        district: 'D38',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_cerro_navia.png",
                        name: "Cerro Navia",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'islademaipo':
                this.setState({
                    comuna: {
                        district: 'D116',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_isla_maipo.png",
                        name: "Isla de Maipo",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'lacisterna':
                this.setState({
                    comuna: {
                        district: 'D119',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_la_cisterna.png",
                        name: "La Cisterna",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'lapintana':
                this.setState({
                    comuna: {
                        district: 'D126',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_la_pintana.png",
                        name: "La Pintana",
                        date: new Date('2019-12-13T09:00:00')
                    }
                });
                break;
            case 'lareina':
                this.setState({
                    comuna: {
                        district: 'D127',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_la_reina.png",
                        name: "La Reina",
                        date: new Date('2019-12-10T15:00:00')
                    }
                });
                break;
            case 'lascondes':
                this.setState({
                    comuna: {
                        district: 'D137',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_las_condes.png",
                        name: "Las Condes",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'limache':
                this.setState({
                    comuna: {
                        district: 'D141',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_limache.png",
                        name: "Limache",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'lobarnechea':
                this.setState({
                    comuna: {
                        district: 'D146',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_barnechea.png",
                        name: "Lo Barnechea",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'macul':
                this.setState({
                    comuna: {
                        district: 'D163',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_macul.png",
                        name: "Macul",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'nunoa':
                this.setState({
                    comuna: {
                        district: 'D189',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_nunoa.png",
                        name: "Ñuñoa",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'paine':
                this.setState({
                    comuna: {
                        district: 'D200',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_paine.png",
                        name: "Paine",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'penalolen':
                this.setState({
                    comuna: {
                        district: 'D215',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_penanolen.png",
                        name: "Peñalolén",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'primavera':
                this.setState({
                    comuna: {
                        district: 'D230',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_primavera.png",
                        name: "Primavera",
                        date: new Date('2019-12-12T00:01:00')
                    }
                });
                break;
            case 'providencia':
                this.setState({
                    comuna: {
                        district: 'D231',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_providencia.png",
                        name: "Providencia",
                        date: new Date('2019-12-13T09:00:00')
                    }
                });
                break;
            case 'quilicura':
                this.setState({
                    comuna: {
                        district: 'D252',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_quilicura.png",
                        name: "Quilicura",
                        date: new Date('2019-12-14T09:00:00')
                    }
                });
                break;
            case 'quilpue':
                this.setState({
                    comuna: {
                        district: 'D256',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_quilpue.png",
                        name: "Quilpué",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'quintero':
                this.setState({
                    comuna: {
                        district: 'D260',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_quinteros.png",
                        name: "Quintero",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'recoleta':
                this.setState({
                    comuna: {
                        district: 'D265',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_recoleta.png",
                        name: "Recoleta",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'sanjoaquin':
                this.setState({
                    comuna: {
                        district: 'D293',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_san_joaquin.png",
                        name: "San Joaquín",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'sanmiguel':
                this.setState({
                    comuna: {
                        district: 'D296',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_san_miguel_dos.png",
                        name: "San Miguel",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'santiago':
                this.setState({
                    comuna: {
                        district: 'D310',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_santiago.png",
                        name: "Santiago",
                        date: new Date('2019-12-13T09:00:00')
                    }
                });
                break;
            case 'temuco':
                this.setState({
                    comuna: {
                        district: 'D317',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_temuco.png",
                        name: "Temuco",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'tiltil':
                this.setState({
                    comuna: {
                        district: 'D321',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_tiltil.png",
                        name: "Til Til",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'valparaiso':
                this.setState({
                    comuna: {
                        district: 'D334',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_valpo.png",
                        name: "Valparaíso",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'villaalemana':
                this.setState({
                    comuna: {
                        district: 'D340',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_villa_alemana.png",
                        name: "Villa Alemana",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            case 'vinadelmar':
                this.setState({
                    comuna: {
                        district: 'D342',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_vina_mar.png",
                        name: "Viña del Mar",
                        date: new Date('2019-12-12T09:00:00')
                    }
                });
                break;
            case 'vitacura':
                this.setState({
                    comuna: {
                        district: 'D343',
                        logo: "https://evoting.s3.amazonaws.com/ConsultaMunicipal/logos_muni/logo_vitacura_dos.jpg",
                        name: "Vitacura",
                        date: new Date('2019-12-11T12:00:00')
                    }
                });
                break;
            default:
                ;

        }
    }

    loadElection = election_id => {
        this.setState({loading: true}, () =>
            axios({
                method: "get",
                url: process.env.REACT_APP_BACKUP_URL +
                    "/" +
                    election_id +
                    "/header.json"
            })
                .then(response => {
                    this.setState({election: response.data, loading: false});
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        axios({
                            method: "get",
                            url: process.env.REACT_APP_API_URL + "/election/" + election_id

                        })
                            .then(response => {
                                this.setState({election: response.data, loading: false});
                            })
                            .catch(error => {
                                this.setState({loading: false});
                            });

                    } else {
                        this.setState({loading: false});
                    }
                })
        );
    };


    loadSnapshot = election_id => {

        this.setState({loading: true}, () =>
            axios({
                method: "get",
                url:
                    process.env.REACT_APP_BACKUP_URL +
                    "/" +
                    election_id +
                    "/snapshot.json"
            })
                .then(response => {
                    this.setState({
                        loading: false,
                        snapshot: response.data
                    });
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        axios({
                            method: "get",
                            url:
                                process.env.REACT_APP_API_URL +
                                "/election/" +
                                election_id +
                                "/snapshot"
                        })
                            .then(response => {
                                this.setState({
                                    loading: false,
                                    snapshot: response.data
                                });
                            })
                            .catch(error => {
                                this.setState({loading: false});
                            });
                    } else {
                        this.setState({loading: false});
                    }
                })
        );
    };

    render() {

        return (

            <div className="container-fluid">

                {!this.state.comuna && (
                    <div className="row EvColorGrisLight mb-4">
                        <div className="col-6 col-sm-4 col-md-3 ">
                            <img src="logo.svg" className="img-fluid logo" alt="logo"/>
                        </div>
                    </div>

                )}


                {this.state.election != null && this.state.snapshot != null && (
                    <Fragment>


                        {this.state.comuna ? (
                            <Header election={this.state.election} logo={this.state.comuna.logo}
                                    date={this.state.comuna.date}/>
                        ) : (
                            <Header election={this.state.election}
                                    date={this.state.election.configuration.start_date.$date}/>

                        )}

                        <div className="row justify-content-center m-4 p-4">
                            <div className="col-12 col-sm-11 col-md-9 col-lg-7 text-center">
                                {this.state.comuna ? (
                                    <h4>Total
                                        votos {this.state.comuna.name}: {this.state.snapshot.districts[this.state.comuna.district].voters.electronic_voted.toLocaleString(navigator.language, {
                                            minimumFractionDigits: 0
                                        })}</h4>
                                ) : (
                                    <h4>Total Votos TODAS LAS
                                        COMUNAS: {this.state.snapshot.voters.electronic_voted.toLocaleString(navigator.language, {
                                            minimumFractionDigits: 0
                                        })}</h4>
                                )}

                            </div>
                        </div>
                        {this.state.comuna ? (
                            <ResultsTable districts={this.state.snapshot.districts}
                                          votantes={this.state.snapshot}
                                          election_id={this.election_id}
                                          district={this.state.comuna.district}
                                          name={this.state.comuna.name}/>
                        ) : (
                            <ResultsTable districts={this.state.snapshot.districts}
                                          votantes={this.state.snapshot}
                                          election_id={this.election_id}

                            />
                        )}
                        <br/><br/>

                    </Fragment>
                )}

                <VotesByHour election_id={this.election_id}/>
                <br/><br/>

                {this.state.snapshot != null && (

                    <TurnoutTable snapshot={this.state.snapshot}/>
                )}


                <br/><br/>
                <Footer/>
            </div>
        );
    }
}


export default Home;